import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { AdminConfiguration } from '../../modules/admin/components';

const Configuration = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>AdminConfiguration.System Settings')} />
      <AdminConfiguration />
    </>
  );
};

export default Configuration;
